import { Observable } from '@jack-henry/frontend-utils/observable';
import { asyncNoOp, noOp } from '@treasury/utils';
import { FeatureFlagService } from './feature-flag.service';
import { FeatureChangedPayload, TmFeatureFlag } from './feature-flag.types';

export const NullFeatureFlagService = {
    ready$: new Observable<boolean>(),
    featureChanged$: new Observable<FeatureChangedPayload>(),
    features: [] as TmFeatureFlag[],
    isEnabled: () => Promise.resolve(false),
    setOverride: noOp,
    getOverride: (): undefined => undefined,
    init: asyncNoOp,
    reset: asyncNoOp,
    reInit: asyncNoOp,
} as unknown as FeatureFlagService;
